<template>
  <aha-modal @hide="hideModal()" :title="modalTitle">
    <p>
      You are about to delete all <u v-tooltip="resultsTooltip" class="cursor-pointer">results</u>
      from participants <b>{{ onThisSlideText }}</b>.
      <span class="block pt-2">
        <aha-icon
          name="shield"
          maintainColor
          svgMaintainColor
          class="mb-1"
        />
        Your own questions and content will not be removed.</span>
    </p>
    <template #action>
      <aha-button
        variant="danger"
        @click="handleClearDataSlide()"
        has-margin-right
      >
        Reset
      </aha-button>
      <aha-link @click="hideModal()">
        <span class="font-bold">Cancel</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'

// api
import SlideApi from '@/api/slide'
import PresentationApi from '@/api/presentation'

// utils
import utils from '@/util'
import EventBus from '@/eventBus'
import PresentationUtils from '@/utils/presentation'
import Socket from '@/socket'

export default {
  props: {
    selectedSlides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slidesToClear: [],
    }
  },
  computed: {
    ...mapState({
      audiences: (state) => state.audiences,
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      currentUser: (state) => state.currentUser,
    }),
    modalTitle() {
      if (this.selectedSlides.length === 1) {
        return `Reset ${this.selectedSlides[0].index ? `slide ${this.selectedSlides[0].index + 1}` : 'this slide'}?`
      }
      return `Reset ${this.selectedSlides.length} slides?`
    },
    resultsTooltip() {
      return '<p>Results include all participants’ <b> votes</b>, and <b>submissions</b>.</p>'
    },
    onThisSlideText() {
      return this.selectedSlides.length > 1 ? `on these ${this.selectedSlides.length} slides` : 'on this slide'
    },
  },
  methods: {
    ...mapActions([
      'updateSlideActiveAction',
      'setSyncLoadingAction',
      'patchPresentationAction',
      'setCurrentUserAction',
    ]),

    handleClearDataSlide() {
      this.slidesToClear = this.selectedSlides.map((s) => ({
        ...s,
        index: this.presentation.slides.findIndex((i) => s.id === i.id),
      }))
      this.selectedSlides.forEach((s) => {
        this.clearLocalDataBasedOnSlideType(s)
      })
      this.reActiveSlide('fromClearDataSlide')
      this.hideModal()
      this.handleCallAPIClearDataSlide()
    },

    clearLocalDataBasedOnSlideType(slide) {
      const index = this.presentation.slides.findIndex((i) => slide.id === i.id)
      const currentSlide = this.presentation.slides[index]
      const slideType = currentSlide.type

      if (slideType === 'question') {
        this.$store.state.countAnswerQuestion = 0
        this.$store.state.countTopQuestion = 0
        this.$store.state.countPinnedQuestion = 0
        this.$store.state.lastQuestion = {}
        this.$store.state.questionCount = 0
        this.$store.state.questions = []
        this.$store.state.tabQnaQuestion = 1
      }

      if (slideType === 'openEnded' || slideType === 'wordCloud' || slideType === 'ideas') {
        currentSlide.SlideOptions = []
      }

      if (slideType === 'spinnerWheel') {
        EventBus.$emit('clearSpinnerWheel', slide.id)
        currentSlide.metadata = {
          ...slide.metadata,
          winner: null,
          entries: null,
          entryUrl: null,
          wheelStatus: null,
        }
        this.$store.state.audiences = {}
        PresentationApi.getAudienceOnline({
          uniqueAccessCode: this.presentation.uniqueAccessCode,
        })
      }

      if (slideType === 'multipleChoice'
          || slideType === 'pickAnswer'
          || slideType === 'imageChoice') {
        currentSlide.SlideOptions.forEach((slideOption) => {
          slideOption.count = 0
        })
      }

      currentSlide.multipleCountAnswer = 0
      currentSlide.votingStep = 'submission'
      currentSlide.ideasCount = 0

      Object.keys(this.audiences).forEach((key) => {
        delete this.audiences[key][slide.id]
      })

      slide.qna = slideType === 'question'
    },

    reActiveSlide(source) {
      const allCurrentSlides = this.presentation.slides
      const slideActiveIndex = allCurrentSlides.findIndex((i) => i.id === this.slideActive.id)

      if (slideActiveIndex > -1) {
        this.$emit('makeSlideActive', allCurrentSlides[slideActiveIndex], null, source)
        setTimeout(() => {
          this.updateSlideActiveAction({
            activeTab: this.selectedSlides.length > 1 ? 3 : 2,
          })
        })
      }
    },

    async handleCallAPIClearDataSlide() {
      try {
        const slideId = this.selectedSlides.map((s) => s.id).filter((i) => !!i)
        this.setSyncLoadingAction(1)
        const payload = {
          socketId: Socket.getSocketId(),
          presentationId: this.$route.params.id,
          slideId,
        }
        await SlideApi.clearSlides(payload)
        PresentationUtils.checkAndUpdatePresentationHasResults()
        this.setSyncLoadingAction(2)
        const slideText = this.selectedSlides.length > 1 ? `${this.selectedSlides.length} slides` : 'the slide'
        utils.showToastSuccess(`Reset results of ${slideText} successfully`)
      } catch (err) {
        this.setSyncLoadingAction(3)
        const slideText = this.selectedSlides.length > 1 ? `${this.selectedSlides.length} slides` : 'the slide'
        utils.showToastError(`Failed to reset results of ${slideText}`)
        throw err
      }
    },

    hideModal() {
      this.$emit('hide')
    },
  },
}
</script>
